const Icon = (props: any) => {
    return (
        <svg width={22} height={18} viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M21 15.222c0 .472-.192.924-.532 1.257a1.84 1.84 0 01-1.286.521H2.818a1.84 1.84 0 01-1.285-.52A1.758 1.758 0 011 15.221V5.444c0-.471.192-.923.533-1.257a1.84 1.84 0 011.285-.52h3.637L8.273 1h5.454l1.819 2.667h3.636c.482 0 .945.187 1.286.52.34.334.532.786.532 1.257v9.778z"
                stroke="currentColor"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11 13.444c2.008 0 3.636-1.592 3.636-3.555 0-1.964-1.628-3.556-3.636-3.556-2.009 0-3.637 1.592-3.637 3.556 0 1.963 1.628 3.555 3.637 3.555z"
                stroke="currentColor"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Icon;
